export default "__VITE_ASSET__BMLnRV8u__"